import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormsService } from '../services/forms/forms.service';

@Component({
	selector: 'app-formular-de-evaluare',
	templateUrl: './formular-de-evaluare.component.html',
	styleUrls: [ './formular-de-evaluare.component.scss' ]
})
export class FormularDeEvaluareComponent implements OnInit {
	form: any = {
		answer1: '',
		answer2: ''
	};
	test: any = {
		answer1_a: '',
		answer1_b: '',
		answer1_c: '',
		answer1_d: '',
		answer1_e: ''
	};
	constructor(private toastr: ToastrService, private formsService: FormsService) {}

	ngOnInit(): void {}

	sendData() {
		const t = this;
		console.log(t.form);

		this.form.answer1 =
			(this.test.answer1_a ? 'Medic specialist,' : '') +
			(this.test.answer1_b ? 'Medic de familie,' : '') +
			(this.test.answer1_c ? 'Cunostinte,' : '') +
			(this.test.answer1_d ? 'Internet,' : '') +
			(this.test.answer1_e ? 'Alte surse,' : '');

		this.formsService.createOrUpdate(t.form).subscribe(
			(data) => {
				t.toastr.success('Chestionar trimis cu succes', 'Chestionar de evaluare');
			},
			(error: any) => {
				this.toastr.error(error.error.message, 'Trimitere forumular');
			}
		);
	}
}
